<template>
    <div @keyup.enter="submitForm" v-if="fetched">
        <d-list-group flush>
            <d-list-group-item class="p-3">
                <d-form-row>
                    <d-col md="6" class="form-group">
                        <ss-input v-model="client.correspondence_street" name="correspondence_street" label="Ulica" placeholder="Ulica"></ss-input>
                    </d-col>
                    <d-col md="6" class="form-group">
                        <ss-input v-model="client.correspondence_house_number" name="correspondence_house_number" label="Nr budynku" placeholder="Nr budynku"></ss-input>
                    </d-col>
                </d-form-row>
                <d-form-row>
                    <d-col md="6" class="form-group">
                        <ss-input v-model="client.correspondence_flat_number" name="correspondence_flat_number" label="Nr lokalu" placeholder="Nr lokalu"></ss-input>
                    </d-col>
                </d-form-row>

                <d-form-row>
                    <d-col md="6" class="form-group">
                        <ss-input v-model="client.correspondence_postcode" name="correspondence_postcode" label="Kod pocztowy" placeholder="Kod pocztowy"></ss-input>
                    </d-col>
                    <d-col md="6" class="form-group">
                        <ss-input v-model="client.correspondence_city" name="correspondence_city" label="Miasto" placeholder="Miasto"></ss-input>
                    </d-col>
                </d-form-row>
            </d-list-group-item>
        </d-list-group>
    </div>
</template>

<script>
    import LarErrors from '../../helpers/Errors';

    export default {
        name: "AddressData",
        components: {
            LarErrors
        },
        props: {
            props: {
                type: Object,
                default: {}
            }
        },
        data(){
            return{
                lar_errors: LarErrors,
                fetched:    false,
                client: {
                    correspondence_street:          '',
                    correspondence_house_number:    '',
                    correspondence_postcode:        '',
                    correspondence_city:            '',
                }
            }
        },
        mounted(){
            this.client = this.props ? this.props : this.client;
            this.fetched = true;
        },
        watch: {
            props: {
                handler: function(to) {
                    this.client = to;
                },
                deep: true
            }
        }
    }
</script>
